import React from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton, StyledDialogAction, StyledDialogHeader, TextBox } from "..";
import { Box, Button, Dialog, DialogContent } from "@mui/material";

const defaultDataSchema = {
    sql_customer_id: '',
};

const validationSchema = yup.object().shape({
    sql_customer_id: yup
        .string()
        .trim()
        .required("SQL Customer ID is required!"),
});

const AddSqlCustomerIdDialog = (props) => {
    const shop = props.shop;

    const { register, handleSubmit, formState: { errors, isDirty } } = useForm({
        mode: 'onChange',
        defaultValues: defaultDataSchema,
        resolver: yupResolver(validationSchema),
        values: {
            sql_customer_id: shop?.sql_customer_id ?? '',
        }
    });

    const onHandleClose = () => {
        props.handleClose();
    };

    const onSubmit = (data) => {
        props.submit(data.sql_customer_id);
    };

    return (
        <Dialog open={props.isOpen} fullWidth maxWidth='sm' sx={{ height: 'auto' }}>
            <StyledDialogHeader title={props.title || "Add SQL Customer ID"} />
            <DialogContent>
                <Box 
                    component={'form'} 
                    onSubmit={handleSubmit(onSubmit)}
                    sx={{ display: 'flex', flexDirection: 'column', '& .MuiInputBase-root': { mb: 0, mt: 3 } }} 
                    noValidate 
                    autoComplete="off" 
                    gap={2}
                >
                    <TextBox
                        label="SQL Customer ID"
                        placeholder="e.g. CUST-10042"
                        error={Boolean(errors.sql_customer_id)}
                        helperText={errors.sql_customer_id?.message}
                        inputProps={register('sql_customer_id')}
                    />
                </Box>
            </DialogContent>
            <StyledDialogAction isError={props.isError || false} errMsg={props.errorMessage || ''}>
                <Button onClick={onHandleClose} variant="outlined">Close</Button>
                <LoadingButton
                    isLoading={props.isLoading ?? false}
                    label="Confirm"
                    onClick={handleSubmit(onSubmit)}
                    loadingIconSize={20}
                    disabled={!isDirty} 
                />
            </StyledDialogAction>
        </Dialog>
    );
};

export default AddSqlCustomerIdDialog;